const DISPOSABLE_DOMAINS = new Set([
    "10minutemail.com", "guerrillamail.com", "mailinator.com", "tempmail.com",
    "throwaway.email", "fakeinbox.com", "dispostable.com", "mailnesia.com",
    "tempail.com", "mohmal.com", "yopmail.com", "guerrillamailblock.com",
    "sharklasers.com", "grr.la", "pokemail.net", "spam4.me", "gishpuppy.com",
    "temp-mail.org", "emailondeck.com", "throwam.com", "getairmail.com",
    "maildrop.cc", "getnada.com", "tempmailaddress.com", "randomail.net",
    "emailfake.com", "mail7.io", "mailboxhub.com", "tempail.com",
    "fake-email.org", "email-temp.com", "tempmailo.com", "fastmail.com",
    "mailinator.org", "disposableemail.com", "discard.email", "mail.gov",
    "incognitomail.com", "spambox.us", "mailcatch.com", "zippymail.info",
    "tempemail.net", "spam.la", "spamfree.eu", "spamfree.org", "spamgoes.in",
    "spamhereplease.com", "spamherelots.com", "spamhole.com", "spamkiller.com",
    "spammotel.com", "spamobox.com", "spamspot.com", "spamthis.co.uk",
    "spamthisplease.com", "supergreatmail.com", "supermailer.jp", "superplatyna.com",
    "supplymail.com", "suremail.info", "svk.jp", "sweetxxx.de", "tafmail.com",
    "tagmymail.com", "tapchicoma.com", "techemail.com", "techgroup.me",
    "teleworm.com", "teleworm.us", "temp-link.net", "temp-mail.com",
    "temp-mail.de", "temp-mail.org", "tempail.com", "tempalias.com",
    "tempe-mail.com", "tempemail.co.za", "tempemail.com", "tempemail.org",
    "tempinbox.co.uk", "tempinbox.com", "tempmail.co", "tempmail.de",
    "tempmail.eu", "tempmail.it", "tempmail.us", "tempmail2.com",
    "tempmaildemo.com", "tempmailer.com", "tempmailer.de", "tempmailo.com",
    "tempomail.fr", "temporaryemail.net", "temporaryemail.us", "temporaryforwarding.com",
    "temporaryinbox.com", "temporarymailaddress.com", "tempthe.net", "tempymail.com",
    "thankyou2010.com", "thc.st", "theaviors.com", "thebearshark.com",
    "thelimestones.com", "themailinator.com", "thembones.com.au", "themostemail.com",
    "themail.com", "themail2.com", "themail3.com", "themail4.com",
    "thismail.net", "thisurl.website", "thraml.com", "thrma.com",
    "throam.com", "thrott.com", "throwawayemail.com", "throwawaymail.com",
    "throwawaymailaddress.com", "throya.com", "thrubay.com", "thunderbolt.scientific.research",
    "tiapz.com", "tic.ec", "tilien.com", "timgiare.com", "timkassouf.com",
    "tinoza.org", "tipidbox.com", "tittbit.in", "tizi.com", "tkitc.de",
    "tlpn.org", "tmail.com", "tmail.net", "tmail.ws", "tmails.net",
    "tmpmail.net", "tmpmail.org", "toddsbighug.com", "toiea.com", "tokem.co",
    "tokenmail.de", "tonymanso.com", "toomail.biz", "top101.de", "top1mail.ru",
    "top1post.ru", "topinrock.cf", "topofertasdehoy.com", "topranklist.de",
    "toprumours.com", "tormail.org", "toss.pw", "tosunkaya.com", "totalvista.com",
    "totesmail.com", "toton123.com", "tp-qa-mail.com", "tqoai.com", "tradermail.info",
    "tranceversal.com", "trash-ads.com", "trash-mail.at", "trash-mail.cf",
    "trash-mail.com", "trash-mail.de", "trash-mail.ga", "trash-mail.gq",
    "trash-mail.ml", "trash-mail.tk", "trash-me.com", "trash2009.com",
    "trash2010.com", "trash2011.com", "trashcanmail.com", "trashdevil.com",
    "trashdevil.de", "trashemail.de", "trashemails.de", "trashinbox.com",
    "trashmail.at", "trashmail.com", "trashmail.de", "trashmail.gq",
    "trashmail.io", "trashmail.me", "trashmail.net", "trashmail.org",
    "trashmail.ws", "trashmailer.com", "trashmailgenerator.de", "trashymail.com",
    "trasz.com", "trayna.com", "trbvm.com", "trbvn.com", "trbvo.com",
    "trgovinanaveliko.net", "trialmail.de", "trickmail.net", "trillianpro.com",
    "trollproject.com", "tropicalbass.info", "trungtamtoeic.com", "tryalert.com",
    "tryninja.io", "tts.co", "tualias.com", "turoid.com", "turual.com",
    "tvchd.com", "tverya.com", "twklyml.com", "twocowmail.net", "twoweirdtricks.com",
    "txtadvertise.com", "tyhe.ro", "tyldd.com", "tympe.net", "uacro.com",
    "ubismail.net", "ubm.md", "ucche.us", "ucupdong.ml", "uemail99.com",
    "ufacturing.com", "uggsrock.com", "uguuchantele.com", "uhe2.com", "uhhu.ru",
    "uiu.us", "ujijima1129.gq", "uk.to", "umail.net", "undo.it", "unids.com",
    "unimark.org", "unionfinan.com", "unmail.ru", "uooos.com", "uorak.com",
    "upliftnow.com", "uplipht.com", "uploadnolimit.com", "upozowac.info",
    "urfunktion.se", "urhen.com", "uroid.com", "us.af", "us.to", "usa.cc",
    "usako.net", "ush.iobb.net", "usmail.top", "utiket.us", "uu2.ovh",
    "uu5.ovh", "uu6.ovh", "uu7.ovh", "uu8.ovh", "uu9.ovh", "uwork4.us",
    "uyhip.com", "vaati.org", "vancemail.xyz", "vankin.de", "vctel.com",
    "vda.ro", "vdig.com", "veanlo.com", "vemomail.win", "venompen.com",
    "veo.kr", "ver0.cf", "ver0.ga", "ver0.gq", "ver0.ml", "ver0.tk",
    "vercelli.cf", "vercelli.ga", "vercelli.gq", "vercelli.ml", "verdejo.com",
    "veryprice.co", "vesa.pw", "vfemail.net", "via.tokyo.jp", "victime.ninja",
    "victoriantwins.com", "vidchart.com", "viditag.com", "viewcastmedia.com",
    "viewcastmedia.net", "vigilantkeep.net", "vigoro.com", "vikingsonly.com",
    "vinernet.com", "vipepe.com", "vipmail.name", "vipmail.pw", "vipxm.net",
    "viralplays.com", "virtualemail.info", "visal007.tk", "visal168.cf",
    "visal168.ga", "visal168.gq", "visal168.ml", "visal168.tk", "vixletdev.com",
    "vkcode.ru", "vmailing.net", "vmpanda.com", "vnedu.me", "vntech.org",
    "vocaloidland.com", "voial.com", "voila21.net", "voltaer.com", "vorga.org",
    "votiputox.org", "voxelcore.com", "vpn.st", "vps30.com", "vps911.net",
    "vradportal.com", "vremya24.com", "vrmtr.com", "vsimcard.com", "vssms.com",
    "vtxmail.us", "vuiy.pw", "vztc.com", "w3internet.co.uk", "w4.gov",
    "wakingupesther.com", "walala.org", "walkmail.net", "walkmail.ru",
    "wallm.com", "wanko.be", "watch-harry-potter.com", "watchever.biz",
    "watchfull.net", "watchironman3onlinefreefullmovie.com", "waterisgone.com",
    "watrf.com", "wavdb.com", "wazabi.club", "wazow.com", "wbml.net",
    "web-ideal.fr", "web-mail.pp.ua", "web.demic.eu", "webcontact-france.eu",
    "webemail.me", "webmail.co.zw", "webtrip.ch", "webuser.in", "wee.my",
    "wef.gr", "wefjo.grn.cc", "wegwerfemail.de", "wegwerfemail.info",
    "wegwerfemail.net", "wegwerfemail.org", "wegwerfemailadresse.com",
    "wegwerfmail.de", "wegwerfmail.info", "wegwerfmail.net", "wegwerfmail.org",
    "wegwrfmail.de", "wegwrfmail.net", "wegwrfmail.org", "wekawa.com",
    "welikecookies.com", "wellsfargocomcard.com", "wemel.com", "wer.ez.lv",
    "wetrainbayarea.com", "wetrainbayarea.org", "wfgdfhj.tk", "wg0.com",
    "wh4f.org", "whatiaas.com", "whatifanalytics.com", "whatpaas.com",
    "whatsaas.com", "whiffles.org", "whopy.com", "whtjddn.33mail.com",
    "whyspam.me", "wibblesmith.com", "wickmail.net", "widaryanto.info",
    "wierie.tk", "wifimaple.com", "wifioak.com", "wikidocuslava.ru", "wilemail.com",
    "willhackforfood.biz", "willselfdestruct.com", "wimsg.com", "winemaven.info",
    "wins.com.br", "wlist.ro", "wmail.cf", "wmail.club", "wokcy.com",
    "wolfsmail.tk", "wollan.info", "worldspace.link", "wpdork.com", "wpg.im",
    "wralawfirm.com", "writeme.us", "wronghead.com", "ws.gy", "wsym.de",
    "wudet.men", "wuespnj.xyz", "wupics.com", "wuzup.net", "wuzupmail.net",
    "wv Inside.com", "wwjmp.com", "wwwnew.eu", "wxnw.net", "x24.com",
    "xagloo.co", "xbaby69.top", "xcode.ro", "xcompress.com", "xcpy.com",
    "xenon.bounceme.net", "xjoi.com", "xl.cx", "xmail.com", "xmaily.com",
    "xn--9kq967o.com", "xn--d-bga.net", "xoxy.net", "xplode.me", "xpo.cc",
    "xqx.luk2.com", "xr.ftpserver.biz", "xsufilmtop.com", "xwaretech.com",
    "xwaretech.info", "xwaretech.net", "xww.ro", "xxhamsterxx.ga", "xxi2.com",
    "xxolittle.com", "xxvk.ru", "xy9ce.tk", "xyzfree.net", "xzsok.com",
    "yabai-oppai.tk", "yahmail.top", "yamail.win", "yanet.me", "yannmail.win",
    "yapped.net", "yaqp.com", "yarnpedia.tk", "ycare.de", "ycn.ro", "ye.vc",
    "yecp.ru", "yedi.org", "yep.it", "yhg.biz", "ynmrealty.com", "yodx.ro",
    "yogamaven.com", "yomail.info", "yoo.ro", "yopmail.com", "yopmail.fr",
    "yopmail.gq", "yopmail.net", "yopmail.org", "yopmail.pp.ua", "yordanmail.cf",
    "yoshi.hirochi.biz", "you-spam.com", "yougotgoated.com", "youmail.ga",
    "youmailr.com", "youneedmore.info", "youpymail.com", "yourdomain.com",
    "youremail.cf", "yourewronghereswhy.com", "yourlms.biz", "yourtube.ml",
    "yroid.com", "yspend.com", "ytpayy.com", "yugasandrika.com", "yui.it",
    "yuirg.com", "ywhmail.com", "ywz.ro", "yyolf.net", "z0d.eu", "z1p.biz",
    "z86.ru", "zaktouni.fr", "zarabotokdoma11.ru", "zasod.com", "zaym-zaym.ru",
    "zcrcd.com", "zdenka.net", "ze.tc", "zebins.com", "zebins.eu", "zehnminuten.de",
    "zehnminutenmail.de", "zemzar.net", "zepp.dk", "zetmail.com", "zfymail.com",
    "zhaohao.eu", "zhcne.com", "zhewei88.com", "zhorachu.com", "zik.dj",
    "zipcad.com", "zipcad.net", "zipo1.gq", "zippymail.info", "zipsendtest.com",
    "zoaxe.com", "zoemail.com", "zoemail.net", "zoemail.org", "zoetropes.org",
    "zombie-hive.com", "zomg.info", "zumpul.com", "zv68.com", "zxcv.com",
    "zxcvbnm.com", "zymuying.com", "zzi.us", "zzrgg.com", "zzz.com",
    "mail.ru", "inbox.ru", "list.ru", "bk.ru",
    // Observed 2026-07-29: throwaway domains driving the signup-bot traffic.
    // ~1,000 accounts between them, 0 EUR revenue, all with fabricated phone numbers.
    "apdtax.com", "aganseo.com", "lasttea.com", "besteya.com", "candaba.com",
    "gicont.com", "diarshop.com", "barumart.com", "doefy.com", "icotz.com",
    "homephit.com", "fishnone.com", "ezimb.com", "asitrai.com", "bevriz.com",
    "divahd.com", "acoxs.com", "disiok.com", "fisedo.com", "dysonc.com",
    "duvips.com", "jctoto.com", "buloan.com", "draperra.com", "luckfeed.com",
    "suahi.com", "kinws.com", "epaynine.com", "meikeya.com", "kingcq.com",
    "luxudata.com", "fivejm.com", "lovadio.com", "noproposal.com", "kierko.com",
    "jobraux.com", "getemail.space", "ubok.space", "mowan666.com", "clowtmail.com",
    "gwshare.com", "rapplo.com"
]);

export function isDisposableEmail(email: string): boolean {
    if (!email || !email.includes('@')) return false;
    const domain = email.split('@')[1].toLowerCase().trim();
    return DISPOSABLE_DOMAINS.has(domain);
}
